import React from 'react'

const Footer2 = () => {
  return (
    <div className='FOOTER2'>
        <div className='footer2'>
            <div className='titree'>
                <div className='titree1'>
                    Newsletter subscription
                </div>
                <div className='titree2'>
                    &copy;
                </div>
            </div>   
            <div className='social'>
                <i className="fab fa-instagram"></i>
                <i className="fab fa-facebook-f"></i>
                <i className="fab fa-twitter"></i>
                <i className="fab fa-youtube"></i>
            </div>                   
        </div>
    </div>
  )
}

export default Footer2